import { supabase } from '../lib/supabase/client';
import { ConsultationRequest } from '../types/models';
import { Database } from '../types/database.types';

type ConsultationRow = Database['public']['Tables']['consultation_requests']['Row'];
type ConsultationInsert = Database['public']['Tables']['consultation_requests']['Insert'];

export const consultationService = {
  async getAll(): Promise<ConsultationRequest[]> {
    const { data, error } = await supabase
      .from('consultation_requests')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    
    return (data || []).map((row: ConsultationRow) => ({
      id: row.id,
      customerName: row.customer_name,
      customerEmail: row.customer_email,
      customerPhone: row.customer_phone,
      consultationType: row.consultation_type,
      projectScope: row.project_scope,
      stylePreferences: row.style_preferences,
      roomDimensions: row.room_dimensions,
      budgetRange: row.budget_range,
      preferredDate: row.preferred_date,
      timeline: row.timeline,
      additionalNotes: row.additional_notes,
      status: row.status,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    }));
  },

  async create(consultation: Omit<ConsultationRequest, 'id' | 'createdAt' | 'updatedAt' | 'status'>): Promise<ConsultationRequest> {
    const insertData: ConsultationInsert = {
      customer_name: consultation.customerName,
      customer_email: consultation.customerEmail,
      customer_phone: consultation.customerPhone,
      consultation_type: consultation.consultationType,
      project_scope: consultation.projectScope,
      style_preferences: consultation.stylePreferences,
      room_dimensions: consultation.roomDimensions,
      budget_range: consultation.budgetRange,
      preferred_date: consultation.preferredDate,
      timeline: consultation.timeline,
      additional_notes: consultation.additionalNotes,
    };

    const { data, error } = await supabase
      .from('consultation_requests')
      .insert(insertData)
      .select()
      .single();
    
    if (error) throw error;
    
    return {
      id: data.id,
      customerName: data.customer_name,
      customerEmail: data.customer_email,
      customerPhone: data.customer_phone,
      consultationType: data.consultation_type,
      projectScope: data.project_scope,
      stylePreferences: data.style_preferences,
      roomDimensions: data.room_dimensions,
      budgetRange: data.budget_range,
      preferredDate: data.preferred_date,
      timeline: data.timeline,
      additionalNotes: data.additional_notes,
      status: data.status,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  },
};